import html2canvas from 'html2canvas'

const EXPORT_WIDTH = 1920

export default function exportFree() {
  const selector = document.querySelector('.image-preview')
  if (!selector) return

  const width = selector.offsetWidth
  const height = selector.offsetHeight
  const scale = EXPORT_WIDTH / width

  html2canvas(selector, {
    allowTaint: true,
    useCORS: true,
    scale,
    width,
    height,
  }).then(canvas => {
    saveAs(canvas.toDataURL('image/png'), 'zoomback-says-thanks.png')
  })
}

function saveAs(uri, filename) {
  var link = document.createElement('a')
  if (typeof link.download === 'string') {
    link.href = uri
    link.download = filename

    document.body.appendChild(link)
    link.click()

    document.body.removeChild(link)
  } else {
    window.open(uri)
  }
}
